import React from 'react';
import { Modal } from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';
import { OfferModuleService } from '../../services/OfferModuleService';
import { allowance, approveTokens } from '../../web3Helper';
import { getNetwork } from '../../web3Utils';
import { toast } from 'react-toastify';

const OfferModel = ({toggle, onCloseModal, inventory}) => {
    const [value, setValue] = React.useState(0);
    const [approvalAmount, setApprovalAmount] = React.useState(0);
    const [offerValue, setOfferValue] = React.useState(0);
    const [days, setDays] = React.useState(0);
    const [isApprovalInProgress, setIsApprovalInProgress] = React.useState(false);
    const [isPlacingOfferInProgress, setIsPlacingOfferInProgress] = React.useState(false);

    let obj = {
      array: []
  };
  for (var l=0;l<20;l++){
      obj.array[l] = l+1;
  }
  console.log("obj: ", obj);
  let optionItems = obj.array.map((item) =>
  
      <option key={item} value={item}>{item}</option>
  );

  const checkAllowance = async () => {

    const offerModuleService = new OfferModuleService();

    if(!value && !days) return toast.error('Purchase Unavailable!');
   
    const allowanceAmount = await allowance({ spenderContractType: offerModuleService.contractType });

    if(allowanceAmount < value) {
      setApprovalAmount(value - allowanceAmount);
    }
    setOfferValue(value)
  }

  const handleApproval = async () => {

    const offerModuleService = new OfferModuleService();

    setIsApprovalInProgress(true);
    try {
      await approveTokens({ value: 1000000, spenderContractType: offerModuleService.contractType });
      setIsApprovalInProgress(false);
      setApprovalAmount(0);
    } catch(err) {
      setIsApprovalInProgress(false);
      setApprovalAmount(0);
      setOfferValue(0)
    } 
  }

  
  const handlePlaceOffer = async () => {

    const offerModuleService = new OfferModuleService();
    const networkId = await getNetwork();
    const tokenId = inventory && inventory['tokenId'][networkId];

    setIsPlacingOfferInProgress(true);
    offerModuleService.placeOffer({
      tokenId,
      value: offerValue,
      expireOffset: days*86400,
    }).then(() => {
      setOfferValue(0);
      setIsPlacingOfferInProgress(false);
      onCloseModal();
      toast.success("Offer Placed Successfully!");
    }).catch((err) => {
      setOfferValue(0);
      setIsPlacingOfferInProgress(false);
      toast.error(err);
    })
  }

  return (
    <Modal open={ toggle } onClose={onCloseModal} closeOnOverlayClick={false}  classNames={ {
      overlay: 'customOverlay',
      modal: 'modal-1' 
    } } center>
      <h5 className='mx-3'>Place offer to purchase the NFT!</h5>
      <button onClick={onCloseModal} className="btn position-absolute top-0 end-0">X</button>
      <div className='mt-4'>
        <input 
          className={`form-control mb-3`}
          onChange={(e) => setValue(e.target.value)}
          placeholder="Offer Value" 
        />
        <div > <select className={`form-control select-control mb-3`}   onChange={(e) => setDays(e.target.value)} style={{ padding:'0rem 1.8rem'}} >
            <option value="" disabled selected>Select No of Days </option>
                        {optionItems}
                    </select></div>
        {
          approvalAmount ? 
            <button onClick={()=> handleApproval()} className="btn buy" disabled={isApprovalInProgress} >
              { isApprovalInProgress ? 'Please Wait!' : `Approve` }
            </button>
          : offerValue ?
            <button onClick={()=> handlePlaceOffer()} className="btn buy" disabled={isPlacingOfferInProgress}>
              { isPlacingOfferInProgress ? 'Please Wait!' : `Confirm Placing Offer ${offerValue} Tokens`}
            </button>
          :
          <button onClick={()=> checkAllowance()} className="btn buy">
            { 'Place Offer' }
          </button>
        }
      </div>
    </Modal>
  )
}
export default OfferModel;